import { utilityAccountSelectionMachine } from '~/machines/utility-account-selection';
import { config } from './config';

export const funnelMachine = () =>
  utilityAccountSelectionMachine({
    id: config.id,
  });
